import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'fixDimensions',
    standalone: false
})
export class FixDimensionsPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }

    transform(text: string): any {

        if (!text) return text;

        // Replace all occurrences of "CO2" with "CO<sub>2</sub>"
        text = text.replace(/CO2/g, 'CO<sub>2</sub>');

        // Replace "m2" with "m<sup>2</sup>"
        text = text.replace(/m2/g, 'm<sup>2</sup>');


        return this.sanitizer.bypassSecurityTrustHtml(text);
    }
}
